import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()(theme => ({
  heading: {
    '-webkitTextFillColor': 'transparent',
    '-webkitTextStroke': `${theme.palette.primary.main} 3px`,
    textTransform: 'uppercase',
    margin: '0 auto -15px',
    fontSize: '60px',
  },
}));

export default function BorderedText({ children }) {
  const { classes } = useStyles();

  return (
    <Typography
      align="center"
      variant="h4"
      className={`${classes.heading} pt-5 pb-2`}
      gutterBottom
      color="primary"
    >
      {children}
    </Typography>
  );
}
